import { useQuery } from '@tanstack/react-query';
import { fetchPreClaimsDocumentTypes } from '../../data-provider/select-options';

export const useGetPreClaimsDocumentTypes = () => {
  return useQuery({
    queryKey: ['pre-claims-document-types'],
    queryFn: () => fetchPreClaimsDocumentTypes(),
    staleTime: Number.POSITIVE_INFINITY,
  });
};
